import { type IStatusConfig, type IStatusProps } from 'shared/ui/Status'
import { type IRcsComplianceStatus } from 'entities/Rcs'

export const rcsStatusConfig: Record<IRcsComplianceStatus, IStatusProps> = {
  in_progress: {
    title: 'In progress',
    icon: 'refreshCircle',
    emphasis: 'high',
    intent: 'informative',
  },
  under_review: {
    title: 'Internal review',
    icon: 'clock',
    emphasis: 'high',
    intent: 'purple',
  },
  twilio_review: {
    title: 'Twilio review',
    icon: 'clock',
    emphasis: 'high',
    intent: 'informative',
  },
  approved: {
    title: 'Approved',
    icon: 'check2',
    emphasis: 'high',
    intent: 'positive',
  },
  rejected: {
    title: 'Rejected',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
  failed: {
    title: 'Rejected',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
}

const rcsClientPendingReviewStatus: IStatusProps = {
  title: 'Pending Review',
  icon: 'clock',
  emphasis: 'high',
  intent: 'informative',
}

export const rcsClientStatusConfig: Record<IRcsComplianceStatus, IStatusProps> = {
  in_progress: rcsClientPendingReviewStatus,
  under_review: rcsClientPendingReviewStatus,
  twilio_review: {
    title: 'In Carrier Review',
    icon: 'clock',
    emphasis: 'high',
    intent: 'informative',
  },
  approved: rcsStatusConfig.approved,
  failed: rcsStatusConfig.rejected,
  rejected: rcsStatusConfig.rejected,
}

export const rcsDetailStatusTitles: Partial<Record<IRcsComplianceStatus, string>> = {
  failed: 'Rejection (internal)',
  rejected: 'Rejection (internal)',
}

export const rcsSettableStatusConfig: IStatusConfig = {
  under_review: rcsStatusConfig.under_review,
  twilio_review: rcsStatusConfig.twilio_review,
  approved: rcsStatusConfig.approved,
  failed: rcsStatusConfig.failed,
}

export const rcsSetStatusConfig: IStatusConfig = {
  under_review: rcsStatusConfig.under_review,
  twilio_review: rcsStatusConfig.twilio_review,
  approved: rcsStatusConfig.approved,
  failed: rcsStatusConfig.failed,
}
